import React, { useState, useEffect } from 'react'
import { Box, Container, Typography, IconButton } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import FirebaseUtil from '../../config/firebase'

const useStyles = makeStyles((theme: Theme) => createStyles({
    bannerContainer: {
        backgroundColor: '#ad2320',
        marginBottom: '3rem',
        color: 'white',
    },
    bannerText: {
        width: '70%',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    navButton: {
        color: 'white',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.15)',
        },
    },
}))

const Banner = () => {
    const classes = useStyles()
    const [messages, setMessages] = useState<string[]>([])
    const [currentIndex, setCurrentIndex] = useState(0)
    const [resetKey, setResetKey] = useState(0)

    useEffect(() => {
        const unsubscribe = FirebaseUtil.firestore
            .collection('banners')
            .onSnapshot(snapshot => {
                const titles = snapshot.docs
                    .map(doc => doc.data().title as string)
                    .filter(Boolean)
                setMessages(titles)
                setCurrentIndex(0)
            })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (messages.length < 2) return
        const timer = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % messages.length)
        }, 5000)
        return () => clearInterval(timer)
    }, [messages.length, resetKey])

    const goPrev = () => {
        setCurrentIndex(prev => (prev - 1 + messages.length) % messages.length)
        setResetKey(k => k + 1)
    }

    const goNext = () => {
        setCurrentIndex(prev => (prev + 1) % messages.length)
        setResetKey(k => k + 1)
    }

    if (messages.length === 0) return null

    return (
        <div className={classes.bannerContainer}>
            <Container maxWidth="xl">
                <Box py={8} display="flex" alignItems="center" justifyContent="space-between">
                    <IconButton
                        className={classes.navButton}
                        onClick={goPrev}
                        disabled={messages.length < 2}
                    >
                        <ArrowBackIosIcon />
                    </IconButton>

                    <Typography variant="h3" component="h2" className={classes.bannerText}>
                        {messages[currentIndex]}
                    </Typography>

                    <IconButton
                        className={classes.navButton}
                        onClick={goNext}
                        disabled={messages.length < 2}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                </Box>
            </Container>
        </div>
    )
}

export default Banner
